import api, { apiRequestPut, getAsyncRefreshHeader } from 'mastodon/api';
import type {
  ApiContextJSON,
  ApiForumTopicRepliesJSON,
  ApiStatusJSON,
} from 'mastodon/api_types/statuses';

import type { ApiQuotePolicy } from '../api_types/quotes';

export const apiGetContext = async (statusId: string) => {
  const response = await api().request<ApiContextJSON>({
    method: 'GET',
    url: `/api/v1/statuses/${statusId}/context`,
  });

  return {
    context: response.data,
    refresh: getAsyncRefreshHeader(response),
  };
};

export const apiSetQuotePolicy = async (
  statusId: string,
  policy: ApiQuotePolicy,
) => {
  return apiRequestPut<ApiStatusJSON>(
    `v1/statuses/${statusId}/interaction_policy`,
    {
      quote_approval_policy: policy,
    },
  );
};

export const apiGetForumTopicReplies = async ({
  statusId,
  page,
  limit,
}: {
  statusId: string;
  page: number;
  limit?: number;
}) => {
  const params = new URLSearchParams({ page: String(page) });
  if (limit) {
    params.set('limit', String(limit));
  }

  const response = await api().request<ApiForumTopicRepliesJSON>({
    method: 'GET',
    url: `/api/v1/zfl/forum_topic_replies/${statusId}?${params.toString()}`,
  });

  return response.data;
};
